import React from 'react';
import { Container } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import { CabinQuickSearch, SectionHeader } from '../../common/components';

const SeasonRates = () => {
  return (
    <>
      <Helmet>
        <title>Hinnoittelu - Sesonkihintakaudet</title>
      </Helmet>

      <Container className="container-content">
        <SectionHeader
          Breadcrumbs={['Hinnoittelu']}
          Title="Sesonkihintakaudet"
        />
        <div className="my-48">
          <CabinQuickSearch
            NavigateUrl="/rates/seasonrates"
            Subtitle="Hae kohde jonka sesonkihintakausia haluat muokata"
            Title="Valitse kohde"
          />
        </div>
      </Container>
    </>
  );
};

export default SeasonRates;
